
import { AssetPreviewTagsController } from './asset-preview-tags.controller'

function assetPreviewTags () {
  return {
    restrict: 'E',
    data: {
      template: '<'
    },
    templateUrl: '/core/directives/asset-preview-tags/asset-preview-tags.html?$$REVISION$$',
    controller: AssetPreviewTagsController
  }
}
export { assetPreviewTags }
